import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper, StepState, STEP_STATE } from '@angular/cdk/stepper';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Optional, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatStep, MatStepper, matStepperAnimations } from '@angular/material/stepper';

@Component({
  selector: 'ness-stepper, ness-vertical-stepper, ness-horizontal-stepper, [nessStepper]',
  exportAs: 'nessStepper, nessVerticalStepper, nessHorizontalStepper',
  templateUrl: 'stepper.component.html',
  styleUrls: ['stepper.component.scss'],
  inputs: ['selectedIndex'],
  host: {
    '[class.mat-stepper-horizontal]': 'orientation === "horizontal"',
    '[class.mat-stepper-vertical]': 'orientation === "vertical"',
    '[class.mat-stepper-label-position-end]':
      'orientation === "horizontal" && labelPosition == "end"',
    '[class.mat-stepper-label-position-bottom]':
      'orientation === "horizontal" && labelPosition == "bottom"',
    '[attr.aria-orientation]': 'orientation',
    'role': 'tablist',
  },
  animations: [
    matStepperAnimations.horizontalStepTransition,
    matStepperAnimations.verticalStepTransition,
  ],
  providers: [
    { provide: CdkStepper, useExisting: NessStepperComponent },
    { provide: MatStepper, useExisting: NessStepperComponent }
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NessStepperComponent extends MatStepper  {
  constructor(
    @Optional() dir: Directionality,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef<HTMLElement>,
    public matIconRegistry: MatIconRegistry) {
    super(dir, changeDetectorRef, elementRef);
    const nodeName = elementRef.nativeElement.nodeName.toLowerCase();
    this.orientation = nodeName === 'ness-vertical-stepper' ? 'vertical' : 'horizontal';
    matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
    matIconRegistry.registerFontClassAlias('fontawesome', 'fas');
  }

  customSelect(index: number): void {
    const step = this.steps.toArray()[index];

    if (index == 0 && step.hasError) {
      return;
    } else {
      step.select();
    }
  }

  _stepIsNavigable(index: number, step: MatStep): boolean {
    return (!step.hasError && step.completed) || this.selectedIndex === index || !this.linear;
  }

  _getIndicatorType(index: number, state: StepState = STEP_STATE.NUMBER): StepState {
    const step = this.steps.toArray()[index];
    const isCurrentStep = this.selectedIndex === index;

      return state;
  }

}
